import axios from 'axios';

export const VoucherAppointmentsApi = {
  getAppointments: filter =>
    axios.get(`/api/self/paging/kindergarten_voucher?filter=${filter}`),
  prolongVoucher: data =>
    axios.post(`/api/public/transitions/kindergarten_voucher/prolong`, data),
  appointmentDownload: requestFormId =>
    axios.get(
      `/api/public/info/request_form_preview/${requestFormId}/voucher?force=true`,
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/csv'
        }
      }
    )
};
